/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Sledovat mou objednávku`
};

const da_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Følg min ordre`
};

const de_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung verfolgen`
};

const en_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Follow my order`
};

const es_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Seguir mi pedido`
};

const fr_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Suivre ma commande`
};

const hu_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelésem nyomon követése`
};

const it_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Traccia il mio ordine`
};

const nl_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Volg mijn bestelling`
};

const pl_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Śledź zamówienie`
};

const pt_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Acompanhar meu pedido`
};

const sv_footer_services_follow_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Följ min beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const footer_services_follow_my_order = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_services_follow_my_order(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_services_follow_my_order", locale)
	if (locale === "cs") return cs_footer_services_follow_my_order(inputs)
	if (locale === "da") return da_footer_services_follow_my_order(inputs)
	if (locale === "de") return de_footer_services_follow_my_order(inputs)
	if (locale === "en") return en_footer_services_follow_my_order(inputs)
	if (locale === "es") return es_footer_services_follow_my_order(inputs)
	if (locale === "fr") return fr_footer_services_follow_my_order(inputs)
	if (locale === "hu") return hu_footer_services_follow_my_order(inputs)
	if (locale === "it") return it_footer_services_follow_my_order(inputs)
	if (locale === "nl") return nl_footer_services_follow_my_order(inputs)
	if (locale === "pl") return pl_footer_services_follow_my_order(inputs)
	if (locale === "pt") return pt_footer_services_follow_my_order(inputs)
	return sv_footer_services_follow_my_order(inputs)
};
export { footer_services_follow_my_order as "footer.services.follow_my_order" }